import React, {createContext, useContext, useState} from "react";
import styled, {css} from "styled-components";
import Dialog from "../components/overlay/Dialog";

const GlobalMessagesDialog = styled(Dialog)`
	h1, p {
		margin: 0;
		text-align: center;
	}
	
	p+p {
		margin-top: 0.25rem;
	}
	
	${props => props.$type === 'success' && css`
		h1 {
			color: var(--primary-color);
		}
	`}
	
	${props => props.$type === 'error' && css`
		h1 {
			color: var(--error-color);
		}
	`}
`;

const GlobalMessagesContext = createContext({
	openGlobalMessagesDialog: (title, message, type) => {},
});

export const GlobalMessagesProvider = ({ children }) => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [dialogState, setDialogState] = useState(null);

	function openGlobalMessagesDialog(title, message, type) {
		setDialogState({title, message, type});
		setIsDialogOpen(true);
	}

	function closeGlobalMessagesDialog() {
		setIsDialogOpen(false);
		setTimeout(() => setDialogState(null), 300);
	}

	return (
		<GlobalMessagesContext.Provider value={{ openGlobalMessagesDialog }}>
			<GlobalMessagesDialog
				isOpen={isDialogOpen}
				onClose={closeGlobalMessagesDialog}
				$type={dialogState?.type}
			>
				{dialogState?.title && <h1>{dialogState.title}</h1>}
				{dialogState?.message && (
					<div>
						{dialogState.message.split('\\n').map((paragraph, index) => (
							<p key={`global_message_paragraph_${index}`}>{paragraph}</p>
						))}
					</div>
				)}
			</GlobalMessagesDialog>
			{children}
		</GlobalMessagesContext.Provider>
	);
};

export default function useGlobalMessages() {
	return useContext(GlobalMessagesContext);
}
